import {
  adjustAdjacentTableWidths,
  normalizeColumnWidths,
} from '../components/DocEditor/utils/tableCellBlocks';

/**
 * Flexible weights for the variables grid:
 * name | type | value | description | scope
 *
 * Chrome (drag, color, actions) stays fixed px. Same trade as doc tables:
 * dragging a divider moves width between the two neighbors; the row stays
 * 100% of the table.
 *
 * Legacy docs stored 4 weights (name, value, description, scope) — type was
 * a fixed 78px track. Those arrays are migrated in place.
 */
export const VARIABLE_FLEX_COL_COUNT = 5;
export const VARIABLE_COL_MIN = 56;
export const DEFAULT_VARIABLE_COLUMN_WIDTHS = [1.05, 0.5, 1.15, 1, 0.85];

const migrateLegacyWidths = (raw) => {
  if (!Array.isArray(raw) || raw.length === 0) return null;
  if (raw.length === 4) {
    return [raw[0], DEFAULT_VARIABLE_COLUMN_WIDTHS[1], raw[1], raw[2], raw[3]];
  }
  return raw.slice(0, VARIABLE_FLEX_COL_COUNT);
};

export const normalizeVariableColumnWidths = (raw) =>
  normalizeColumnWidths(migrateLegacyWidths(raw), VARIABLE_FLEX_COL_COUNT) ||
  [...DEFAULT_VARIABLE_COLUMN_WIDTHS];

/** CSS grid-template-columns. `minmax(0, Nfr)` so neighbors can actually shrink. */
export const variableColumnsTemplate = (widths, { includeDrag = true } = {}) => {
  const flex = normalizeVariableColumnWidths(widths)
    .map((w) => `minmax(0, ${w}fr)`)
    .join(' ');
  return includeDrag ? `22px 28px ${flex} 56px` : `22px ${flex} 44px`;
};

/** Grow `leftIndex` by `deltaPx`, take it from the next column. Total unchanged. */
export const adjustAdjacentColumnWidths = (
  widths,
  leftIndex,
  deltaPx,
  minPx = VARIABLE_COL_MIN
) =>
  adjustAdjacentTableWidths(
    normalizeVariableColumnWidths(widths),
    leftIndex,
    deltaPx,
    minPx
  );
